import { render, staticRenderFns } from "./CustomerVoicePostEdit.vue?vue&type=template&id=5311a332&"
import script from "./CustomerVoicePostEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerVoicePostEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports